const getStartOfToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

export const isSunday = (date) => date?.getDay?.() === 0;

export const isPastCalendarDate = (date) => {
  if (!date) {
    return false;
  }

  const candidate = new Date(date);
  candidate.setHours(0, 0, 0, 0);

  return candidate < getStartOfToday();
};

export const isBlockedScheduleDate = (date) =>
  isSunday(date) || isPastCalendarDate(date);

export const flatpickrScheduleDateDisable = [
  (date) => isBlockedScheduleDate(date),
];

export const getNextAllowedScheduleDate = (date) => {
  const nextDate = new Date(date);

  while (isSunday(nextDate)) {
    nextDate.setDate(nextDate.getDate() + 1);
  }

  return nextDate;
};
